import config from '../config';
import { jwtDecode } from 'jwt-decode';
import { Auth0JWT } from 'components/common/props-types';

let expire: Date;
let currentToken: string;

let _getAccessTokenSilently: CallableFunction;

export function getCurrentToken(): string {
  return currentToken;
}

export function InitAuth0TokenManager(getAccessTokenSilently: CallableFunction): void {
  _getAccessTokenSilently = getAccessTokenSilently;
}

export async function Auth0TokenManager(token: string): Promise<string> {
  if (expire && new Date() > expire) {
    const result = await _getAccessTokenSilently({
      cacheMode: 'off',
      authorizationParams: {
        prompt: 'none',
        audience: config.AUTH0_LOGIN_AUDIENCE,
        redirect_uri: window.location.origin,
        scope: 'openid profile email',
        grant_type: 'refresh_token',
      },
      detailedResponse: true,
    });
    token = result.access_token;
  }
  if (!expire || currentToken != token) {
    const { exp } = jwtDecode<Auth0JWT>(token);
    expire = new Date(exp * 1000); //exp est en secondes au lieu de milisecondes
    currentToken = token;
  }
  return token;
}
